export default "__VITE_ASSET__bfee9961__"